<template>
    <div id="richTextEditorForm" class="richText">
        <input :id="inputId" type="hidden" name="content" :value="modelObject[textField]">
        <!-- updated here -->
        <trix-editor :input="inputId"></trix-editor>
    </div>
</template>

<script>

export default {
    name: 'Vue3TrixEditor',
    props: ["inputId", 'modelObject', 'textField'],
    data() {
        return {
            trixText: "",
            // attachmentPath: '/api/v1/attachments.json',
            // timerId: null,
        };
    },
    mounted() {
        document.addEventListener("trix-change", this.updateRichText)
        document.addEventListener("trix-focus", this.onFocus)
        document.addEventListener("trix-blur", this.onFocusOut)
    },
    beforeUnmount: function() {
        document.removeEventListener("trix-change", this.updateRichText)
        document.removeEventListener("trix-focus", this.onFocus)
        document.removeEventListener("trix-blur", this.onFocusOut)
    },
    methods: {
        updateRichText(e) {
            this.modelObject[this.textField] = document.getElementById(this.inputId).value;
        },
        onFocus() {
            this.$emit('onFocus');
        },
        onFocusOut() {
            this.$emit('onFocusOut');
            // if(this.timerId) {
            //     console.log('stopping timer')
            //     clearInterval(this.timerId)
            // }
            //
            // this.timerId = null
            // this.saveDocument()
        },
        // saveDocument() {
        //     if(this.document['id']) {
        //         this.dataService.save(this.document)
        //     }
        // }
    },
};
</script>